import { DisplayDownIcon, DisplayUpIcon } from '@genially/icons';

import { FlapContainer } from './FlapButton.styled';

interface FlapButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const FlapButton = ({ isOpen, onClick }: FlapButtonProps) => {
  return (
    <FlapContainer
      onClick={onClick}
      aria-label={isOpen ? 'close reactions' : 'open reactions'}
    >
      {isOpen ? <DisplayDownIcon /> : <DisplayUpIcon />}
    </FlapContainer>
  );
};
